// Google Analytics 4 event tracking utility
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export const trackEvent = (eventName: string, params?: Record<string, string | number>) => {
  if (window.gtag) {
    window.gtag("event", eventName, params);
  }
};

// Conversion events
export const trackDevisClick = (source: string) =>
  trackEvent("cta_devis_click", { event_category: "conversion", event_label: source });

export const trackFormSubmit = (source: string) => {
  trackEvent("form_submit", { event_category: "conversion", event_label: source });
  if (window.gtag) {
    window.gtag("event", "conversion", {
      send_to: "AW-17914583801/GuGzCOb5upEcEPm1q95C",
      value: 1.0,
      currency: "EUR",
      event_callback: () => console.log("Conversion tracked"),
    });
  }
};

export const trackWhatsAppClick = (source: string) =>
  trackEvent("whatsapp_click", { event_category: "conversion", event_label: source });

export const trackPhoneClick = () => {
  trackEvent("phone_click", { event_category: "conversion", event_label: "cta_appel" });
  if (window.gtag) {
    window.gtag("event", "conversion", {
      send_to: "AW-17914583801/In2YCOn5upEcEPm1q95C",
      value: 1.0,
      currency: "EUR",
    });
  }
};
